"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterRpcLocal = exports.createRouteMessageAck = void 0;
const utils_1 = require("@streamr/utils");
const DhtRpc_1 = require("../../../generated/packages/dht/protos/DhtRpc");
const RoutingSession_1 = require("./RoutingSession");
const identifiers_1 = require("../../identifiers");
const uuid_1 = require("uuid");
const logger = new utils_1.Logger(module);
const createRouteMessageAck = (routedMessage, error) => {
    const ack = {
        requestId: routedMessage.requestId,
        error
    };
    return ack;
};
exports.createRouteMessageAck = createRouteMessageAck;
class RouterRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async routeMessage(routedMessage) {
        if (this.options.duplicateRequestDetector.isMostLikelyDuplicate(routedMessage.requestId)) {
            logger.trace(`Routing message ${routedMessage.requestId} from ${(0, identifiers_1.toNodeId)(routedMessage.sourcePeer)} `
                + `to ${(0, identifiers_1.toDhtAddress)(routedMessage.target)} is likely a duplicate`);
            return (0, exports.createRouteMessageAck)(routedMessage, DhtRpc_1.RouteMessageError.DUPLICATE);
        }
        logger.trace(`Processing received routeMessage ${routedMessage.requestId}`);
        this.options.duplicateRequestDetector.add(routedMessage.requestId);
        if ((0, utils_1.areEqualBinaries)(this.options.localPeerDescriptor.nodeId, routedMessage.target)) {
            logger.trace(`routing message targeted to self ${routedMessage.requestId}`);
            this.options.setForwardingEntries(routedMessage);
            this.options.handleMessage(routedMessage.message);
            return (0, exports.createRouteMessageAck)(routedMessage);
        }
        else {
            return this.options.doRouteMessage(routedMessage);
        }
    }
    async forwardMessage(forwardMessage) {
        if (this.options.duplicateRequestDetector.isMostLikelyDuplicate(forwardMessage.requestId)) {
            logger.trace(`Forwarding message ${forwardMessage.requestId} from ${(0, identifiers_1.toNodeId)(forwardMessage.sourcePeer)} `
                + `to ${(0, identifiers_1.toDhtAddress)(forwardMessage.target)} is likely a duplicate`);
            return (0, exports.createRouteMessageAck)(forwardMessage, DhtRpc_1.RouteMessageError.DUPLICATE);
        }
        logger.trace(`Processing received forward routeMessage ${forwardMessage.requestId}`);
        this.options.duplicateRequestDetector.add(forwardMessage.requestId);
        if ((0, utils_1.areEqualBinaries)(this.options.localPeerDescriptor.nodeId, forwardMessage.target)) {
            return this.forwardToDestination(forwardMessage);
        }
        else {
            return this.options.doRouteMessage(forwardMessage, RoutingSession_1.RoutingMode.FORWARD);
        }
    }
    forwardToDestination(routedMessage) {
        logger.trace(`Forwarding found message targeted to self ${routedMessage.requestId}`);
        const forwardedMessage = routedMessage.message;
        if ((0, identifiers_1.areEqualPeerDescriptors)(this.options.localPeerDescriptor, forwardedMessage.targetDescriptor)) {
            this.options.handleMessage(forwardedMessage);
            return (0, exports.createRouteMessageAck)(routedMessage);
        }
        return this.options.doRouteMessage({ ...routedMessage, requestId: (0, uuid_1.v4)(), target: forwardedMessage.targetDescriptor.nodeId });
    }
}
exports.RouterRpcLocal = RouterRpcLocal;
//# sourceMappingURL=RouterRpcLocal.js.map